"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.platformNotConnected.title': 'Konto niepołączone',
    'socialMediaPlan.platformNotConnected.message': 'Następujące platformy są wybrane, ale nie mają podłączonego konta w Ustawieniach:',
    'socialMediaPlan.platformNotConnected.hint': 'Przejdź do Ustawień → Social Media, aby połączyć konta przed publikacją.',
    'socialMediaPlan.platformNotConnected.chipTitle': 'Konto niepołączone — przejdź do Ustawień, aby powiązać tę platformę',
    'socialMediaPlan.platformNotConnected.chipHint': 'Niektóre platformy nie są połączone.',
    'socialMediaPlan.platformNotConnected.goToSettings': 'Przejdź do Ustawień',
};
